import { Link } from "react-router-dom";
import { config } from "@/lib/config";
import React from "react";

const JoinButton = () => {
  return (
    <div className="mb-20 mt-8 w-full animate-bounce p-4 text-center animate-infinite">
      <Link
        to={`${config.basePath}/kapcsolat/csi-festes`}
        className="rounded-md bg-red-500 p-4 text-center font-bold text-white"
      >
        Jelentkezz most!
      </Link>
    </div>
  );
};

export default function Csifestes() {
  return (
    <>
      <div>
        <h1 className="beart-title">
          <div className="flex">
            <div className="text-4xl text-amber-700">Csí-festés</div>
            <div className="ml-8 mt-3 italic text-amber-900">
              Tengelyembe mozdulok
            </div>
          </div>
        </h1>
        <div className="mt-4">
          Öt alkalmas integrál szemléletű mozgás (csikung, tajcsi) és
          művészetterápiás önismereti csoport a belső egyensúlyról és a
          határokról.
        </div>
      </div>
      <div className="m-0 mb-20 mt-20 flex w-full justify-center p-0">
        <div>
          <Link to={`${config.basePath}/kapcsolat/csi-festes`}>
            <img
              src={`${config.basePath}/images/csi/csifestes-tengely.jpg`}
              alt="Csí-festés"
              className="mx-auto w-[75%] border-2 border-blue-700 brightness-100 drop-shadow-2xl hover:scale-110 hover:brightness-110"
            />
          </Link>
        </div>
      </div>
      <div className="mt-10 flex justify-center bg-amber-700 bg-opacity-20 p-4">
        <blockquote>
          „Alattad a föld, fölötted az ég, benned a létra." &mdash; Weöres
          Sándor
        </blockquote>
      </div>
      <div className="mt-10 flex">
        <div className="p-2">
          <i className="bi bi-tree text-3xl text-green-900"></i>
        </div>
        <div>
          A viharban a fákat ide-oda csavarja a szél. A vihar elvonul, és a fa
          legtöbbször a helyén marad. Te érezted már, hogy időnként kegyetlenül
          megrángat az élet vihara? Hogy nehéz helyezetekben bizonytalanná
          válsz? Érezted már, hogy nincs elég energiád ellenállni? Hogy nehezen
          mondasz nemet, és kerülöd a konfliktusokat?
        </div>
      </div>
      <div className="mt-4 border-2 border-green-700 border-opacity-30 p-4">
        A határok meghúzása alapvető fontosságú a mentális egészség védelme
        érdekében. A határok határozzák meg, hogy mik vagyunk és mik nem. Miért
        vállalunk felelősséget és mi mások felelőssége. Ha vannak határaink, fel
        tudjuk ismerni a saját szükségleteinket, és képesek vagyunk azokat
        kommunikálni mások felé.
      </div>
      <div className="mt-8 font-bold text-amber-700">
        Aki alkot, az a tengelyében áll. Kimozdul, cselekszik, majd újra
        visszatér a belső erőközpontjába.
      </div>
      <div className="mt-8 border-2 border-blue-700 border-opacity-30 p-4">
        <div className="">
          Az öt alkalmas foglalkozás sorozaton a <em>fizikai kimozdulást</em>,
          majd a <em>visszatérést</em> a csikung és a tajcsi mozdulatai adják
          meg, az érzelmi és gondolati középpontba térést, az alkotás a
          művészetterápia eszközei segítik. Kijelölöd a határaidat, és képes is
          vagy megtartani azokat. Gazdag, holisztikus megközelítést kínálunk
          számodra az önismeret és a személyes fejlődés útján.
        </div>
        <div className="mt-4">
          A csoportban számos eszközt kapsz - melyeket aztán egyénileg tovább
          tudsz fejleszteni - hogy jobban megértsd önmagadat, hogy képes legyél
          kijelölni és megtartani a határaidat. Az elsajátított eszközök
          segítenek érzelmeid kifejezésében, és abban, hogy visszatalálj belső
          egyensúlyodhoz, kapcsolódj saját erődhöz.
        </div>
      </div>
      <div className="mt-4 flex">
        <div className="p-2">
          <i className="bi bi-brush text-3xl text-blue-900"></i>
        </div>
        <div>
          A Csí-festés lényege, hogy megteremtjük azokat a feltételeket, melyek
          biztosítják a benned lévő energiák szabad áramlását. Csikung, tajcsi
          gyakorlás közben ráhangolódsz azokra az érzetekre, amelyeket saját
          tested a külvilágból közvetít számodra, a művészetterápiás gyakorlatok
          során pedig olyan technikákat ismersz meg, melyekkel
          feszültségmentesen, ellazultan válaszolhatsz a kihívásokra.
        </div>
      </div>
      <div className="beart-title">Kiknek ajánljuk a programot?</div>
      <div className="mt-4">18 évestől &mdash; 99 éves korig, bárkinek.</div>
      <div className="mt-4 font-bold italic">
        Semmilyen előzetes rajztudás vagy tajcsi és csikung tapasztalat nem
        szükséges a részvételhez!
      </div>
      <div className="beart-subtitle">Alkalmak:</div>
      <div>
        Októbertől szombatonként 16<sup>30</sup> – 20<sup>30</sup>-ig.
      </div>
      <ul className="mt-2">
        <li>2024. október 19.</li>
        <li>2024. november 2.</li>
        <li>2024. november 16.</li>
        <li>2024. november 30.</li>
        <li>2024. december 14.</li>
      </ul>
      <div className="mt-8">
        <strong>Maximális létszám:</strong> 12 fő
      </div>
      <div className="mt-4">
        <em>Zárt csoport</em>, ami annyit jelent, hogy elköteleződsz az
        alkalmakra, az öt alkalmat ugyanazokkal a csoporttagokkal viszed végig,
        biztonságos teret adva így a mélyebb folyamatoknak.
      </div>

      <div className="mt-8">
        <strong>Helyszín:</strong>
        <div>
          Budapest, Astoria - 1053 Budapest, Kossuth Lajos u. 17. III/6.{" "}
          <i>(van lift)</i>
        </div>

        <div className="mt-4">
          <div style={{ width: "100%" }}>
            <iframe
              width="100%"
              height="400"
              frameBorder="0"
              scrolling="no"
              marginHeight={0}
              marginWidth={0}
              src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=en&amp;q=%20Budapest,%20Astoria%20-%201053%20Budapest,%20Kossuth%20Lajos%20u.%2017.%20III/6.+(Csi-fest%C3%A9s)&amp;t=&amp;z=17&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            ></iframe>
          </div>
        </div>
      </div>
      <JoinButton />
      <div className="mt-8">
        <div className="beart-subtitle">A csoport díja:</div>
        <div>12.000 Ft / alkalom, összesen: 60.000 Ft</div>
        <div>
          Az összeg tartalmazza az összes eszközt + egy kis teát, gyümölcsöt és
          ropogtatni valót is.
        </div>

        <div>
          <div className="beart-subtitle">Jelentkezés feltétele:</div>
          <div>
            Az első alkalom díjának befizetése a jelentkezési határidőig: 12.000
            Ft
          </div>
          <div>
            <div className="beart-subtitle">Jelentkezési határidő:</div>
            <div>2024. október 10.</div>
            <div className="beart-subtitle">Lemondási határidő:</div>
            <div>2024. október 14.</div>
            <div className="beart-title mt-30">A FOGLALKOZÁST VEZETIK</div>
            <div className="flex w-full justify-center">
              <img
                width={500}
                src={`${config.basePath}/images/csi/csi-foglalkozast-vezetok.jpg`}
                alt="Bíró Beáta és Csányi Zita"
              />
            </div>
            <div className="mt-8 gap-8 lg:flex">
              <div className="mt-8 text-justify">
                <strong>Bíró Beáta</strong> – BeArt művészetterápia, art
                coaching Fejlesztési szakember, művészetterápiás csoportvezető,
                art coach, mentálhigiénés szakember, integrál szemléletű család-
                és rendszerállító
              </div>
              {/* <div className="hidden w-full justify-center lg:flex">
                <img
                  width={500}
                  src={`${config.basePath}/images/csi/csi-foglalkozast-vezetok.jpg`}
                  alt="Bíró Beáta és Csányi Zita"
                />
              </div>*/}
              <div className="mt-8 text-justify">
                <strong>Csányi Zita</strong> – Belső Ösvény Taiji Iskola Tanár,
                taiji, meditáció és csikung oktató, buddhista tanító, integrál
                önismereti mentor a Belső Ösvény Taiji Iskola és a Belső Ösvény
                Központ vezetője, a Magyar Taiji Kulturális Központ elnöke
              </div>
            </div>

            <div className="mt-8 flex w-full justify-evenly">
              <div>
                <div className="beart-subtitle">Neked szól a program, ha</div>
                <ul>
                  <li>
                    <i className="bi bi-check text-green-900"></i> mindig is
                    kipróbálnád milyen csikungozni,
                  </li>
                  <li>
                    <i className="bi bi-check text-green-900"></i> ha érdekel
                    egy művészetterápiás foglalkozás
                  </li>
                  <li>
                    <i className="bi bi-check text-green-900"></i> ha kíváncsi
                    vagy önmagadra.
                  </li>
                </ul>
              </div>
              <div>
                <div className="beart-subtitle">
                  Nem neked szól a program, ha
                </div>
                <ul>
                  <li>
                    <i className="bi bi-x text-red-900"></i> utálsz mozogni,
                  </li>
                  <li>
                    <i className="bi bi-x text-red-900"></i> frászt kapsz a
                    színektől,
                  </li>
                  <li>
                    <i className="bi bi-x text-red-900"></i> hidegen hagy, hogy
                    mi történik benned.
                  </li>
                </ul>
              </div>
            </div>
            <div className="mt-8 flex w-full justify-center">
              <div className="text-center">
                <div className="font-bold">Várunk szeretettel!</div>
                <div>Zita és Bea</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <JoinButton />
    </>
  );
}
